export const rankingList = [
  {
    id: "r01",
    rank: 1,
    title: "龙脊山脉的远征",
    score: 9.1,
    followers: "164.3万",
    trend: "up",
    tag: "冒险 · 战斗",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20an%20adventuring%20party%20crossing%20a%20dragon%20spine%20mountain%20range%2C%20heroic%20rose%20and%20amber%20palette%2C%20clean%20epic%20landscape%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-11&orientation=portrait",
  },
  {
    id: "r02",
    rank: 2,
    title: "剑与月的誓约",
    score: 9.0,
    followers: "156.4万",
    trend: "same",
    tag: "战斗 · 奇幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20swordswoman%20holding%20a%20glowing%20blade%20under%20a%20large%20moon%2C%20deep%20rose%20and%20gold%20palette%2C%20clean%20night%20background%2C%20epic%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-05&orientation=portrait",
  },
  {
    id: "r03",
    rank: 3,
    title: "机械心脏的低语",
    score: 9.3,
    followers: "142.1万",
    trend: "up",
    tag: "科幻 · 悬疑",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20cyberpunk%20girl%20with%20a%20glowing%20mechanical%20heart%2C%20neon%20warm%20amber%20and%20pink%20accents%2C%20clean%20dark%20background%2C%20sci%20fi%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-03&orientation=portrait",
  },
  {
    id: "r04",
    rank: 4,
    title: "银翼空战团",
    score: 9.0,
    followers: "137.2万",
    trend: "down",
    tag: "战斗 · 科幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20female%20pilot%20in%20a%20futuristic%20aircraft%20above%20clouds%2C%20dynamic%20rose%20and%20amber%20palette%2C%20clean%20sky%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-14&orientation=portrait",
  },
  {
    id: "r05",
    rank: 5,
    title: "星尘旅者的黄昏",
    score: 9.1,
    followers: "128.6万",
    trend: "same",
    tag: "奇幻 · 冒险",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20young%20traveler%20in%20a%20long%20coat%20standing%20on%20a%20cliff%20under%20a%20starry%20twilight%20sky%2C%20warm%20pink%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20detailed%20vertical%20poster%20composition&width=600&height=900&seq=anime-cover-01&orientation=portrait",
  },
  {
    id: "r06",
    rank: 6,
    title: "迷雾档案馆",
    score: 9.2,
    followers: "119.5万",
    trend: "up",
    tag: "悬疑 · 奇幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20librarian%20holding%20a%20lantern%20inside%20a%20misty%20endless%20archive%2C%20muted%20rose%20and%20teal%20green%20palette%2C%20clean%20mysterious%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-08&orientation=portrait",
  },
  {
    id: "r07",
    rank: 7,
    title: "无声侦探社",
    score: 9.2,
    followers: "108.9万",
    trend: "up",
    tag: "悬疑 · 推理",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20calm%20detective%20in%20a%20quiet%20study%20with%20clues%20on%20a%20desk%2C%20muted%20rose%20and%20green%20palette%2C%20clean%20mystery%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-16&orientation=portrait",
  },
  {
    id: "r08",
    rank: 8,
    title: "极夜列车",
    score: 9.0,
    followers: "102.8万",
    trend: "new",
    tag: "悬疑 · 奇幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20mysterious%20night%20train%20crossing%20a%20snowy%20polar%20landscape%2C%20moody%20rose%20and%20amber%20palette%2C%20clean%20cinematic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-24&orientation=portrait",
  },
  {
    id: "r09",
    rank: 9,
    title: "武道少年行",
    score: 8.9,
    followers: "99.7万",
    trend: "down",
    tag: "运动 · 战斗",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20martial%20arts%20boy%20training%20in%20an%20old%20dojo%20at%20dawn%2C%20earthy%20rose%20and%20amber%20palette%2C%20clean%20dynamic%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-21&orientation=portrait",
  },
  {
    id: "r10",
    rank: 10,
    title: "深海回声",
    score: 9.1,
    followers: "94.6万",
    trend: "up",
    tag: "悬疑 · 科幻",
    cover: "https://readdy.ai/api/search-image?query=Cel%20shaded%20anime%20illustration%20of%20a%20diver%20listening%20to%20mysterious%20echoes%20in%20a%20dark%20trench%2C%20muted%20rose%20and%20teal%20palette%2C%20clean%20mysterious%20background%2C%20vertical%20poster&width=600&height=900&seq=anime-cover-20&orientation=portrait",
  },
];

export const siteStats = [
  { label: "在追新番", value: "48", unit: "部" },
  { label: "本周更新话数", value: "126", unit: "话" },
  { label: "收录条目", value: "2,340", unit: "条" },
  { label: "每日更新时段", value: "18:00", unit: "起" },
];